import React from "react";
import { motion } from "framer-motion";
import { KeyRound, ShieldAlert, FileWarning } from "lucide-react";
import { StatTile } from "@/components/common/Panel";
import { staggerContainer, staggerItem } from "@/lib/motion";
import { TID } from "@/lib/testIds";

export function RoleStatsTiles({ stats }) {
    return (
        <motion.div variants={staggerContainer} initial="initial" animate="animate" className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <motion.div variants={staggerItem}><StatTile testId={TID.statTile("total-roles")} label="Roles Engineered" value={stats?.total_roles ?? "—"} sub="in current library" icon={KeyRound} tone="cyan" /></motion.div>
            <motion.div variants={staggerItem}><StatTile testId={TID.statTile("conflicted-roles")} label="Roles w/ Conflicts" value={stats?.roles_with_conflicts ?? "—"} sub="SoD toxic combos" icon={ShieldAlert} tone="amber" /></motion.div>
            <motion.div variants={staggerItem}><StatTile testId={TID.statTile("critical-roles")} label="Critical Risk Roles" value={stats?.critical_roles ?? "—"} sub="require redesign" icon={FileWarning} tone="red" /></motion.div>
            <motion.div variants={staggerItem}><StatTile testId={TID.statTile("total-conflicts")} label="Total SoD Conflicts" value={stats?.total_conflicts ?? "—"} sub="across all roles" icon={ShieldAlert} tone="red" /></motion.div>
        </motion.div>
    );
}
